import { getCRC32 } from 'utils/crc32';
import { IncomingPacket, OutcomingPacket } from 'utils/BinaryPacket';
import Blowfish from 'utils/Blowfish';

const ENABLE_BLOWFISH = process.env.REACT_APP_ENABLE_BLOWFISH === "true";

export function Deferred() {
    var self = this;
    this.promise = new Promise(function (resolve, reject) {
        self.reject = reject
        self.resolve = resolve
    })
}

// WebSocket wrapper
export function Socket() {

    if (ENABLE_BLOWFISH) {
        console.log(`Blofwish enabled`);
    }

    var _self = this;

    // Private methods and variables.

    var PING_INTERVAL = 15000;

    // Message codes.
    var MSG_SID_LOGIN = 0x0F;
    var MSG_LOGIN = 0x10;
    var MSG_GETBALANCE = 0x11;
    var MSG_INTEROP = 0x12;
    var MSG_SETDENOMINATION = 0x14;
    var MSG_SETDENOMINATION_EX = 0x0016;
    var MSG_ZEROCREDITS = 0x15;
    var MSG_ADDCREDITS = 0x001A;
    var MSG_PANIC = 0x21;
    var MSG_USER_GETGAMELIST = 0x0028;
    var MSG_GETREALBALANCE = 0x29;
    var MSG_DISCONNECTUSER = 0x2B;
    var MSG_REBOOT = 0x2C;
    var MSG_GETJACKPOTSETTINGSEX = 0x36;
    var MSG_GETDENOMINATION = 0x3D;
    var MSG_CLIENT_GETCHIPCOST = 0x55;
    var MSG_CLIENT_GETCURRENCYCODE = 0x003A;
    var MSG_SENDDATA = 0x001B;
    var MSG_UNKNOWN_FATAL = -1;
    var GAME_SERVER = 0x0001;
    var MSG_GETJACKPOTHISTORY = 0x0057;
    var MSG_ROOT_PING = 0x007F;
    var MSG_GET_UID = 0x000E;
    var MSG_TOURNAMENTCLOSED = 0x0025;
    var MSG_SYNC_BALANCE = 0x0058;
    var MSG_GET_CASHBACK_BONUS = 0x001D;
    var MSG_TAKE_CASHBACK_BONUS = 0x001C;
    var MSG_EXIT_GAME = 0x0020;

    var MSG_CLIENT_GET_FIXED_BET_PRICE = 0x0027;
    var MSG_CMD_JSON = 0x0017;
    var MSG_GET_AVAILABLE_BONUSES = 0x0026;

    // Response handlers array.
    var responseHandlers = {};

    // Initial Blowfish key.
    var defaultKey = [0x6B, 0x60, 0xCB, 0x5B, 0x82, 0xCE, 0x90, 0xB1, 0xCC, 0x2B, 0x6C, 0x55, 0x6C, 0x6C, 0x6C, 0x6C];

    function fixBalanceOverflow(value) {
        var maxInt32 = 0x7FFFFFFF;
        if (value >= maxInt32) {
            value = 0;
            if (_self.inGameMode) {
                alert("A technical problem has occured. Please try to restart the game or call attendant");
                window.parent.postMessage({ msg: 'closeGame' }, '*');
                throw new Error("Balance overflow");
            }
        }
        return value;
    }

    // createRequest creates request with the specified command code.
    function createRequest(code, capacity) {

        // The default value of capacity inside OutcomingPacket is 64.
        var packet = new OutcomingPacket(capacity);

        packet.writeInt16(GAME_SERVER);
        packet.writeInt16(code);

        if (code === MSG_LOGIN) {
            packet.writeString(_self.auth.login);
            packet.writeString(_self.auth.password);
        } else {
            if (_self.useUUID) {
                packet.writeInt32(_self.auth.sidLo);
                packet.writeInt32(_self.auth.sidHi);
                packet.writeInt32(_self.auth.key1);
                packet.writeInt32(_self.auth.key2);
            } else {
                packet.writeUint64(_self.auth.sid);
                packet.writeInt32(_self.auth.key1);
                packet.writeInt32(_self.auth.key2);
            }

            if (code === MSG_SID_LOGIN) {
                var userName = _self.config.username || "";
                packet.writeString(userName);
            }
        }

        return packet;
    };

    // encrypt encrypts the given network packet.
    function encrypt(packet) {
        var encrypted = packet.align(8);
        var buffer, crc;

        crc = getCRC32(encrypted.getBuffer(), 0);

        encrypted.writeUint32(crc);
        encrypted.writeUint32(0);

        buffer = encrypted.getBuffer();
        if (ENABLE_BLOWFISH) {
            _self.blowfish.encrypt(buffer);
        }

        crc = (new Uint32Array(buffer))[0];

        var result = new OutcomingPacket();
        result.writeUint32(encrypted.size + 4); // packet length
        result.writeBuffer(buffer); // encrypted payload
        result.writeUint32(getCRC32(buffer, crc));

        return result;
    };

    // decrypt decrypts the given network packet.
    function decrypt(buffer) {
        var data = buffer.slice(4, buffer.byteLength);
        if (ENABLE_BLOWFISH) {
            _self.blowfish.decrypt(data);
        }

        return data;
    };

    // updateBlowfish takes the new key from the given buffer and updates the encryptor.
    function updateBlowfish(buffer) {
        var view = new Uint8Array(buffer);
        _self.bfKey = view.slice(86, 102);
        _self.blowfish = new Blowfish(_self.bfKey);
    };

    // sendPacket encrypts and sends the given request.
    function sendPacket(packet) {
        var p = encrypt(packet).getBuffer();
        _self.bytesSent += p.byteLength;
        _self.socket.send(p);
    };

    // safeExecute executes the given callback if it is a function.
    function safeExecute(cb) {
        if (cb && typeof cb === "function") {
            cb.apply(this, [].slice.call(arguments, 1));
            return true;
        }
        return false;
    }

    // Public variables and methods.

    _self.blowfish = new Blowfish(defaultKey);
    _self.bfKey = defaultKey;

    _self.connected = false;
    _self.isLogged = false;

    // Websocket protocol settings.
    _self.settings = {
        url: null,
        protocol: 'stargame_protocol',
        binaryType: 'arraybuffer'
    };

    // Authentication parameters.
    _self.auth = {};
    _self.config = {};
    _self.socket = null;
    _self.useUUID = false;

    // State storage (used to restore the main functions when Amatic game is closed).
    _self.state = {};
    _self.errorCode = 0;

    // The total number of bytes received.
    _self.bytesReceived = 0;

    // The total number of bytes sent.
    _self.bytesSent = 0;

    _self.pingInterval = null;

    // isConnected checks whether or not the connection established with the server.
    _self.isConnected = function () {
        return _self.socket && _self.socket.readyState === _self.socket.OPEN;
    };

    // connect connects to the server and invokes the provided callback when ready.
    _self.connect = function (callback) {
        _self.bytesReceived = 0;
        _self.bytesSent = 0;

        if (!_self.isConnected()) {
            safeExecute(_self.onStartConnect);

            _self.blowfish = new Blowfish(defaultKey);
            _self.socket = new WebSocket(_self.config.host, _self.config.protocol || "stargame_protocol");
            _self.socket.binaryType = "arraybuffer";
            _self.socket.onmessage = _self.responseHandler;

            _self.socket.onopen = function () {
                _self.connected = true;
                safeExecute(_self.onConnect);
                safeExecute(callback, null);

                if (_self.pingInterval) {
                    clearInterval(_self.pingInterval);
                }

                _self.pingInterval = setInterval(() => {
                    _self.ping();
                }, PING_INTERVAL);
            }

            _self.socket.onclose = function () {
                if (_self.connected) {
                    _self.connected = false;
                    _self.isLogged = false;
                    if (_self.pingInterval) {
                        clearInterval(_self.pingInterval)
                        _self.pingInterval = null;
                    }
                    safeExecute(_self.onConnectionBroken);
                }
            }

            _self.socket.onerror = function (event) {
                safeExecute(callback, event);
                safeExecute(_self.onError);
            }
        } else {
            safeExecute(callback, null);
        }
    };

    // disconnects gracefully disconnects from the server.
    _self.disconnect = function (callback) {
        _self.socket.onclose = function () { };
        _self.isLogged = false;
        _self.socket.close();
        safeExecute(callback, null);
    };

    // setAuthParams sets an authentification parameters.
    _self.setAuthParams = function (params) {
        if (params.sid !== undefined && params.sidLo === undefined && params.sidHi === undefined) {
            params.sidLo = params.sid;
            params.sidHi = 0;
        }
        _self.auth.sid = params.sid || params.SID;
        _self.auth.sidLo = params.sidLo;
        _self.auth.sidHi = params.sidHi;
        _self.auth.key1 = params.key1 || params.KEY1;
        _self.auth.key2 = params.key2 || params.KEY2;
        _self.auth.operatorId = _self.auth.operatorId || params.operatorid;
        _self.useUUID = !!params.useUUID;

        _self.auth.login = params.login || '';
        _self.auth.password = params.password || '';
    };

    // Response handler
    _self.responseHandler = function (event) {
        var data = decrypt(event.data);

        var response = new IncomingPacket(data);
        var command = 0;
        var ec = 0;

        _self.bytesReceived += event.data.byteLength;

        try {
            response.readUint16();
            command = response.readUint16();
            ec = response.readUint16();
        } catch (e) {
            ec = 1;
        }

        if (command in responseHandlers) {
            responseHandlers[command](response, ec);
        }
    };

    // externalHandler is used by AMATIC games
    _self.externalHandler = function (code, param) {
        switch (code) {
            case MSG_PANIC:
            case MSG_REBOOT:
                _self.onPanic(param);
                break;
            case MSG_DISCONNECTUSER:
                break;
            case MSG_UNKNOWN_FATAL:
                _self.socket.close();
                break;
            default:
        }
    };

    // saveHandlers saves the main websocket handlers.
    _self.saveHandlers = function () {
        _self.state.onopen = _self.socket.onopen;
        _self.state.onmessage = _self.socket.onmessage;
        _self.state.onclose = _self.socket.onclose;
        _self.state.onerror = _self.socket.onerror;
    };

    // restoreHandlers restores the main websocket handlers.
    _self.restoreHandlers = function () {
        if (_self.state.onmessage) {
            _self.socket.onopen = _self.state.onopen;
            _self.socket.onmessage = _self.state.onmessage;
            _self.socket.onerror = _self.state.onerror;

            _self.state.onmessage = null;
        }
    };

    // Requests family

    // loginSID authenticates user by session keys.
    _self.loginSID = function (callback) {
        safeExecute(_self.onStartLogin);
        _self._onLoginResponse = callback;
        var packet = createRequest(MSG_SID_LOGIN);
        sendPacket(packet);
    };

    // loginBypass performs the fake login (used in desktop client).
    _self.loginBypass = function (parameters, callback) {

        safeExecute(_self.onStartLogin);
        _self._onLoginResponse = callback;

        _self.blowfish = new Blowfish(new Uint8Array(parameters.bfKey.split(',')));

        var result = {};

        _self.isLogged = true;

        result.error = 0;
        result.sid = parameters.sid;
        result.key1 = parameters.key1;
        result.key2 = parameters.key2;

        result.denomination = +parameters.denomination;
        result.maxBetPerLine = +parameters.maxBetPerLine;
        result.creditsLimit = +parameters.creditsLimit;
        result.balance = fixBalanceOverflow(+parameters.balance);
        result.denominationEnable = +parameters.denominationEnable;
        result.denominationmin = +parameters.denominationmin;
        result.denominationmax = +parameters.denominationmax;

        safeExecute(_self._onLoginResponse, result);
        safeExecute(_self.onLoginResponse, result);
    };

    // login authenticates user by login and password.
    _self.login = function (callback) {
        safeExecute(_self.onStartLogin);
        _self._onLoginResponse = callback;
        var packet = createRequest(MSG_LOGIN);
        sendPacket(packet);
    }

    // getChipCost returns the price of a single chip for roulette.
    _self.getChipCost = function (callback) {
        _self._onGetChipCost = callback;
        var packet = createRequest(MSG_CLIENT_GETCHIPCOST);
        sendPacket(packet);
    };

    // getCurrencyCode returns the currency code.
    _self.getCurrencyCode = function (callback) {
        _self._onGetCurrencyCode = callback;
        var packet = createRequest(MSG_CLIENT_GETCURRENCYCODE);
        sendPacket(packet);
    };

    // getFixedBetPrice returns the fixed bet price.
    _self.getFixedBetPrice = function (providerCode, currencyCode, callback) {
        _self._onGetFixedBetPrice = callback;

        // The default value of capacity inside OutcomingPacket is 64.
        var packet = new OutcomingPacket();

        packet.writeInt16(GAME_SERVER);
        packet.writeInt16(MSG_CLIENT_GET_FIXED_BET_PRICE);
        packet.writeInt64(_self.auth.sidLo, _self.auth.sidHi);
        packet.writeInt32(_self.auth.key1);
        packet.writeInt32(_self.auth.key2);

        packet.writeInt32(providerCode);//SLOTPROVIDER
        packet.writeInt32(currencyCode);//CURRENCY
        sendPacket(packet);
    };

    // getJackpotValue returns the current jackpot values.
    _self.getJackpotValue = function (callback) {
        _self._onGetJackpotValue = callback;
        var packet = createRequest(MSG_GETJACKPOTSETTINGSEX);
        sendPacket(packet);
    };

    // getJackpotHistory gets the jackpot history
    _self.getJackpotHistory = function (callback) {
        _self._onGetJackpotHistory = callback;
        var packet = createRequest(MSG_GETJACKPOTHISTORY);
        sendPacket(packet);
    };

    // getBalance returns the current player balance.
    _self.getBalance = function (callback) {
        _self._onGetBalance = callback;
        var packet = createRequest(MSG_GETBALANCE);
        sendPacket(packet);
    };

    // getCashbackBonus returns the current player cashback bonus.
    _self.getCashbackBonus = function (callback) {
        _self._onGetCashbackBonus = callback;
        var packet = createRequest(MSG_GET_CASHBACK_BONUS);
        sendPacket(packet);
    };

    // takeCashbackBonus transfers the player cashback bonus to the balance.
    _self.takeCashbackBonus = function (callback) {
        _self._onTakeCashbackBonus = callback;
        var packet = createRequest(MSG_TAKE_CASHBACK_BONUS);
        sendPacket(packet);
    };

    // getRealBalance returns the current player real balance in money.
    _self.getRealBalance = function (callback) {
        _self._onGetRealBalance = callback;
        var packet = createRequest(MSG_GETREALBALANCE);
        sendPacket(packet);
    };

    // syncBalance synchronizes the player balance with the database and returns the real balance in money.
    _self.syncBalance = function (callback) {
        _self._onSyncBalance = callback;
        var packet = createRequest(MSG_SYNC_BALANCE);
        sendPacket(packet);
    };

    // getUserGameList returns the list of active games.
    _self.getUserGameList = function (callback) {
        _self._onGetUserGameList = callback;
        var packet = createRequest(MSG_USER_GETGAMELIST);
        sendPacket(packet);
    };

    // setDenomination sets the current denomination index.
    _self.setDenomination = function (index, callback) {
        _self._onSetDenomination = callback;
        var packet = createRequest(MSG_SETDENOMINATION);
        packet.writeInt8(index);
        sendPacket(packet);
    };

    // setDenominationEx sets the current denomination value in cents.
    _self.setDenominationEx = function (value, callback) {
        _self._onSetDenominationEx = callback;
        var packet = createRequest(MSG_SETDENOMINATION_EX);
        packet.writeInt32(value);
        sendPacket(packet);
    };

    // getDenomination gets the current denomination value.
    _self.getDenomination = function (callback) {
        _self._onGetDenomination = callback;
        var packet = createRequest(MSG_GETDENOMINATION);
        sendPacket(packet);
    };

    // getUidAndHallId gets the current user id and hall id.
    _self.getUidAndHallId = function (callback) {
        _self._onGetUid = callback;
        var packet = createRequest(MSG_GET_UID);
        sendPacket(packet);
    };

    _self.sendJsonRequest = function (gameId, requestId, data, callback) {
        _self._onSendJsonRequest = callback;
        var packet = createRequest(MSG_CMD_JSON);
        packet.writeInt16(gameId);
        packet.writeInt32(requestId);
        packet.writeString(data);
        sendPacket(packet);
    };

    _self.sendGetAvailableBonuses = function (callback) {
        _self._onSendGetAvailableBonuses = callback;
        var packet = createRequest(MSG_GET_AVAILABLE_BONUSES);
        sendPacket(packet);
    };

    // interop sends a special interop data request.
    _self.interop = function (data, callback) {
        _self._onInteropResponse = callback;
        var packet = createRequest(MSG_INTEROP);
        packet.writeBuffer(data);
        sendPacket(packet);
    };

    // gameSpecificRequest sends a special data request.
    _self.gameSpecificRequest = function (gameIndex, data, callback) {
        _self._onGameSpecificResponse = callback;
        var packet = createRequest(MSG_SENDDATA);
        packet.writeInt16(gameIndex);
        packet.writeInt16(data.length);
        packet.writeBuffer(data.getBuffer());
        sendPacket(packet);
    };

    // bet sends a bet.
    _self.bet = function (data, callback) {
        _self._onBetResponse = callback;
        var packet = createRequest(MSG_INTEROP);
        packet.writeBuffer(data);
        sendPacket(packet);
    };

    _self.ping = function (callback) {
        _self._onPingResponse = callback;
        var packet = createRequest(MSG_ROOT_PING);
        sendPacket(packet);
    }

    _self.exitGame = function (callback) {
        _self._onExitGame = callback;
        var packet = createRequest(MSG_EXIT_GAME);
        sendPacket(packet);
    };

    responseHandlers[MSG_GETJACKPOTHISTORY] = function (response, ec) {
        var result = {
            last: {},
            top: {}
        };

        if (ec) {
            result.error = ec;
        } else {
            var readValues = function (target, hasCounter) {
                ["bronze", "silver", "gold", "diamond"].forEach(function (type) {
                    target[type] = {
                        amount: response.getUint64(),
                        player: response.getUint32(),
                        time: response.getUint32()
                    }
                    if (hasCounter) {
                        target[type].counter = response.getUint32();
                    }
                });
            };
            readValues(result.last, true);
            readValues(result.top);
        }

        safeExecute(_self._onGetJackpotHistory, result);
        safeExecute(_self.onGetJackpotHistory, result);
    };

    _self.sendGamblingMachineMessage = function (data) {
        var packet = new OutcomingPacket();

        packet.writeInt16(0x7777); // magic number (gambling machine indicator)
        packet.writeInt16(MSG_CMD_JSON); // opcode
        packet.writeInt16(0); // error code

        packet.writeInt32(0); // request ID
        packet.writeString(data);

        sendPacket(packet);
        console.log("Sent gambling machine message");
    };

    // responseHandlers is an array of the internal response handlers.
    responseHandlers[MSG_SID_LOGIN] = function (response, ec) {
        updateBlowfish(response.buffer);
        var result = {};

        if (ec) {
            _self.isLogged = false;
            result.error = ec;
        } else {
            _self.isLogged = true;

            result.error = 0;
            result.sid = response.getUint32(6);
            result.key1 = response.getUint32(14);
            result.key2 = response.getUint32(18);

            result.denomination = response.getUint32(22);
            result.maxBetPerLine = response.getUint32(26);
            result.creditsLimit = response.getUint32(30);

            result.balance = fixBalanceOverflow(response.getUint32(46));
            result.gamepercent = response.getUint32(50);
            result.internetcost = response.getUint32(54);
            result.percentofdeposittobonus = response.getUint32(58);
            result.minmoneylimitbonu = response.getUint32(62);
            result.cyberplatenable = response.getUint32(66);
            result.browserenable = response.getUint32(70);

            result.denominationEnable = response.getUint32(74);
            result.denominationmin = response.getUint32(78);
            result.denominationmax = response.getUint32(82);

            response.getUint32();
            response.getUint32();
            response.getUint32();
            response.getUint32();

            response.getUint32();
            response.getUint32();
            response.getUint32();
            response.getUint32();
            response.getUint32();
            response.getUint32();
            response.getUint32();
            response.getUint32();

            response.getUint32();
            response.readString();

            response.getUint32();

            result.switching = response.getUint32();
            result.stretching = response.getUint32();
        }

        safeExecute(_self._onLoginResponse, result);
        safeExecute(_self.onLoginResponse, result);
    };

    responseHandlers[MSG_LOGIN] = responseHandlers[MSG_SID_LOGIN];

    responseHandlers[MSG_CLIENT_GETCHIPCOST] = function (response, ec) {

        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.cardChipPrice = response.getUint32(6);
            result.rouletteChipPrice = response.getUint32(10);
            result.tableMaxBet = response.getUint32(14);
            result.tableMinBet = response.getUint32(18);
        }

        safeExecute(_self._onGetChipCost, result);
        safeExecute(_self.onGetChipCost, result);
    }

    responseHandlers[MSG_CLIENT_GETCURRENCYCODE] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.currencyCode = response.getUint32(6);
            result.currencyName = response.getString();
            result.showDenomination = response.getUint32();
            result.bplMul = response.getUint32();

            response.getUint32(); // _current_currency MAINAMA
            response.getUint32(); // _current_currency REDTIGER
            response.getUint32(); // _current_currency PRAGMATIC
            response.getUint32(); // _current_currency COOLFIRE1
            response.getUint32(); // _current_currency COOLFIRE2
            response.getUint32(); // _current_currency MERCUR
            response.getUint32(); // _current_currency IGT
            response.getUint32(); // _current_currency IGROSOFT
            response.getUint32(); // _current_currency GAMEART
            response.getUint32(); // _current_currency EGT
            response.getUint32(); // _current_currency BETSOFT
            response.getUint32(); // _current_currency BALLY
            response.getUint32(); // _current_currency ARISTOCRAT
            response.getUint32(); // _current_currency APEX
            response.getUint32(); // _current_currency AMATIC
            response.getUint32(); // _current_currency NETENT

            response.getUint32(); // reserved
            response.getUint32(); // reserved
            response.getUint32(); // reserved
            response.getUint32(); // reserved
            response.getUint32(); // reserved
            response.getUint32(); // reserved
            response.getUint32(); // reserved
            response.getUint32(); // reserved
            response.getUint32(); // reserved
            response.getUint32(); // reserved

            result.isVirtual = response.getUint32();
        }
        safeExecute(_self._onGetCurrencyCode, result);
        safeExecute(_self.onGetCurrencyCode, result);
    }

    responseHandlers[MSG_CLIENT_GET_FIXED_BET_PRICE] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.fixedBetPrice = response.getUint32(6);
        }
        safeExecute(_self._onGetFixedBetPrice, result);
        safeExecute(_self.onGetFixedBetPrice, result);
    }

    responseHandlers[MSG_GETJACKPOTSETTINGSEX] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            var cnt = response.getUint8(6);
            result.bronze = 0;
            result.silver = 0;
            result.gold = 0;
            result.diamond = 0;
            if (cnt) {
                result.bronze = response.getUint64(7);
                result.bronzeFixed = response.getUint64();
                result.silver = response.getUint64();
                result.silverFixed = response.getUint64();
                result.gold = response.getUint64();
                result.goldFixed = response.getUint64();
                result.diamond = response.getUint64();
                result.diamondFixed = response.getUint64();
                response.readString();
                result.hidden = !response.getUint8();
            }
        }

        safeExecute(_self._onGetJackpotValue, result);
        safeExecute(_self.onGetJackpotValue, result);
    }

    responseHandlers[MSG_GETBALANCE] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.balance = fixBalanceOverflow(response.getUint32(6));
        }

        safeExecute(_self._onGetBalance, result);
        safeExecute(_self.onGetBalance, result);
    }

    responseHandlers[MSG_GET_CASHBACK_BONUS] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.balance = fixBalanceOverflow(response.getUint32(6));
            result.cashbackBonus = response.getInt32();
        }

        safeExecute(_self._onGetCashbackBonus, result);
        safeExecute(_self.onGetCashbackBonus, result);
    }

    responseHandlers[MSG_TAKE_CASHBACK_BONUS] = function (_, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
        }

        safeExecute(_self._onTakeCashbackBonus, result);
        safeExecute(_self.onTakeCashbackBonus, result);
    }

    responseHandlers[MSG_GETREALBALANCE] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.balance = fixBalanceOverflow(response.getUint32(6, true));
        }

        safeExecute(_self._onGetRealBalance, result);
        safeExecute(_self.onGetRealBalance, result);
    }

    responseHandlers[MSG_SYNC_BALANCE] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.balance = fixBalanceOverflow(response.getUint32(6, true));
        }

        safeExecute(_self._onSyncBalance, result);
        safeExecute(_self.onSyncBalance, result);
    }

    responseHandlers[MSG_USER_GETGAMELIST] = function (response, ec) {
        var result = [];

        if (!ec) {
            var buffer = response.getString(6);
            result = buffer.substring(buffer.indexOf('{') + 1, buffer.indexOf('}')).split(',').map(Number);
        }

        safeExecute(_self._onGetUserGameList, result);
        safeExecute(_self.onGetUserGameList, result);
    }

    responseHandlers[MSG_ADDCREDITS] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.value = response.getInt32(6, true);
        }

        safeExecute(_self.onChangeBalance, result);
    }

    responseHandlers[MSG_ZEROCREDITS] = function (response, ec) {
        var result = {};
        result.error = ec;

        safeExecute(_self.onResetBalance, result);
    }

    responseHandlers[MSG_PANIC] = function (response, ec) {
        var url = response.readString(6);
        // eslint-disable-next-line no-useless-escape
        url = _self.isDesktop ? "desktop.notifications.panic" : (window.location.protocol + "//" + url.replace(/^https?\:\/\//i, ""));
        safeExecute(_self.onPanic, url);
    }

    responseHandlers[MSG_REBOOT] = responseHandlers[MSG_PANIC];

    responseHandlers[MSG_SETDENOMINATION] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.balance = fixBalanceOverflow(response.getUint32(6));
            result.bonusMoney = response.getUint32(10);
            result.denomination = response.getUint8(14);
        }

        safeExecute(_self._onSetDenomination, result);
        safeExecute(_self.onSetDenomination, result);
    }

    responseHandlers[MSG_SETDENOMINATION_EX] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.balance = fixBalanceOverflow(response.getUint32(6));
            result.bonusMoney = response.getUint32(10);
            result.denomination = response.getUint8(14);
        }

        safeExecute(_self._onSetDenominationEx, result);
        safeExecute(_self.onSetDenominationEx, result);
    }

    responseHandlers[MSG_GET_AVAILABLE_BONUSES] = function (response, ec) {
        var result = {};
        if (ec) {
            result.error = ec;
            console.warn(`MSG_GET_AVAILABLE_BONUSES error: ${ec}`);
        } else {
            result.error = 0;
            result.type = response.getUint32(6);
            result.gamePermit = response.getUint32(10);
            result.freespinsTotal = response.getUint32(14);
            result.freespinsLeft = response.getUint32(18);
            result.lines = response.getUint32(22);
            result.bet = response.getUint32(26);
            result.denom = response.getUint32(30);
            console.log(`Bonus data received:`, JSON.stringify(result));
        }

        safeExecute(_self._onSendGetAvailableBonuses, result);
        safeExecute(_self.onSendGetAvailableBonuses, result);
        safeExecute(_self.onBonusReceived, result);
    }

    responseHandlers[MSG_INTEROP] = function (response, ec) {
        if (!safeExecute(_self._onInteropResponse, response)) {
            safeExecute(_self._onBetResponse, response);
            safeExecute(_self.onBetResponse, response);
        }
    }

    responseHandlers[MSG_SENDDATA] = function (response, ec) {
        safeExecute(_self._onGameSpecificResponse, response);
        safeExecute(_self.onGameSpecificResponse, response);
        _self._onGameSpecificResponse = null;
    }

    responseHandlers[MSG_GETDENOMINATION] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;

            result.denomination = response.getUint32(6);
            result.balance = fixBalanceOverflow(response.getUint32(10));
            result.bonusMoney = response.getUint32(14);
            result.depositBonus = response.getUint32(18);
            result.curencyCode = response.getUint32(22);
            result.currencyName = response.getString(26);
            result.hidedenomflag = response.getUint32();
        }

        safeExecute(_self._onGetDenomination, result);
        safeExecute(_self.onGetDenomination, result);
    }

    responseHandlers[MSG_ROOT_PING] = function (response, ec) {
        safeExecute(_self._onPingResponse);
        safeExecute(_self.onPingResponse);
    }

    responseHandlers[MSG_GET_UID] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.uid = response.getUint32(6);
            result.hallId = response.getUint32();
        }

        safeExecute(_self._onGetUid, result);
        safeExecute(_self.onGetUid, result);
    }

    responseHandlers[MSG_TOURNAMENTCLOSED] = function (response, ec) {

        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;

            result.id = response.getUint64(6);
            result.value = response.getUint32(14);
            result.balance = response.getUint32(18);
        }

        safeExecute(_self.onTournamentClosed, result);
    }

    responseHandlers[MSG_EXIT_GAME] = function (_, ec) {
        var result = {};
        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
        }
        safeExecute(_self._onExitGame, result);
    }

    responseHandlers[MSG_CMD_JSON] = function (response, ec) {
        var result = {};

        if (ec) {
            result.error = ec;
        } else {
            result.error = 0;
            result.requestId = response.getInt32();
            result.data = response.getString();
        }

        safeExecute(_self._onSendJsonRequest, result);
        safeExecute(_self.onSendJsonRequest, result);
    }

};